export default __webpack_public_path__ + "static/media/people.af85c9a2.png";